import { isUndefined } from 'lodash-es';

import { getAnnotationsTracksHeight } from './get-annotations-tracks-height.js';

const DEFAULT_VISIBLE_ANNOTATIONS_TRACKS = 3;

/**
 * Calculates annotations' vertical visible area in the ChartGrid.
 *
 * @param numTracks - The number of tracks you want to consider for the annotations vertical area
 * @param visibleTracksAmountLimit - The limit amount of visible tracks. When `undefined`, equals to the total number of tracks.
 * @param numHiddenTracks - The number of hidden tracks. The default equals to 0. Depending on the amount of hidden tracks, the visible area will be reduced to compensate the area the should not be displayed.
 * @returns The annotations' visible vertical area in pixels in the ChartGrid.
 */
export const getAnnotationsVisibleArea = (
  numTracks: number,
  visibleTracksAmountLimit: number = DEFAULT_VISIBLE_ANNOTATIONS_TRACKS,
  numHiddenTracks: number = 0,
) => {
  const sanitizedNumHiddenTracks = numHiddenTracks < 0 ? 0 : numHiddenTracks;
  const totalTracksHeight = getAnnotationsTracksHeight(
    numTracks - sanitizedNumHiddenTracks,
  );
  const isVisibleTracksAmountLimitDefined = !isUndefined(
    visibleTracksAmountLimit,
  );

  return isVisibleTracksAmountLimitDefined
    ? Math.min(
        getAnnotationsTracksHeight(visibleTracksAmountLimit),
        totalTracksHeight,
      )
    : totalTracksHeight;
};
